"use strict";

var _regeneratorRuntime = require("/codebuild/output/src964079882/src/gunsy-landing/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

function deserializerMiddleware(options, deserializer) {
  var _this = this;

  return function (next) {
    return function (args) {
      return tslib_1.__awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$next, response, parsed;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return next(args);

              case 2:
                _yield$next = _context.sent;
                response = _yield$next.response;
                _context.next = 6;
                return deserializer(response, options);

              case 6:
                parsed = _context.sent;
                return _context.abrupt("return", {
                  response: response,
                  output: parsed
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    };
  };
}

exports.deserializerMiddleware = deserializerMiddleware;